import React, { createContext, useContext, useState, useCallback } from 'react';
import { ToastContainer } from '../components/ToastNotification';

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children, onToastClick }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, chatData = {}) => {
    const id = Date.now();
    const newToast = {
      id,
      message,
      duration: 5000,
      ...chatData
    };
    
    setToasts(prev => [...prev, newToast]);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  const handleToastClick = useCallback((toast) => {
    if (onToastClick && toast.chatId) {
      onToastClick(toast);
    }
  }, [onToastClick]);

  return (
    <ToastContext.Provider value={{ addToast, removeToast }}>
      {children}
      <ToastContainer 
        toasts={toasts} 
        removeToast={removeToast}
        onToastClick={handleToastClick}
      />
    </ToastContext.Provider>
  );
};